module.exports = __webpack_public_path__ + "Roboto-LightItalic.056caeabe95749fe2b97.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.ttf
// module id = 93
// module chunks = 11